import { useEffect } from 'react';

export default function useGTM({ eager = false }: { eager?: boolean } = {}) {
  useEffect(() => {
    let isLoaded = false;

    const loadGTM = () => {
      if (isLoaded || document.getElementById('gtm-script')) return;

      isLoaded = true;
      const script = document.createElement('script');
      script.id = 'gtm-script';
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-W4F4XCR4';
      document.head.appendChild(script);

      // Initialize dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
    };

    // Eager mode: skip the deferral and listeners. Needed on routes like
    // /thank-you/* where the hard browser redirect leaves no time for the
    // 8s timer or user interaction to fire before the tab is closed.
    if (eager) {
      loadGTM();
      return;
    }

    // Load GTM after meaningful user interaction or after 8 seconds
    const events = ['click', 'keydown', 'touchstart'];
    const autoLoad = () => {
      events.forEach((event) => document.removeEventListener(event, loadGTM, true));
      loadGTM();
    };

    // Add event listeners for loading on meaningful interaction only
    events.forEach((event) => document.addEventListener(event, autoLoad, true));

    // Fallback: Load after 8 seconds (much later)
    const timer = setTimeout(autoLoad, 8000);

    return () => {
      clearTimeout(timer);
      events.forEach((event) => document.removeEventListener(event, autoLoad, true));
    };
  }, [eager]);
}
